module.exports = __webpack_public_path__ + "static/media/output-report-mobilesense.d05772d8.jpg";